/**
 * Bepaalt de logische "parent"-route van een pathname door het laatste
 * pad-segment te strippen. Gebruikt als fallback-bestemming voor de
 * `BackButton` wanneer er geen in-app history is (deep-link / PWA koude start).
 *
 * Pure helper, geen dependencies — bewust testbaar zonder DOM of Next.
 *
 *   `/verlof/123`  → `/verlof`
 *   `/a/b/c`       → `/a/b`
 *   `/x`           → `/`
 *   `/`            → `/`
 *
 * Trailing slashes en lege segmenten worden genegeerd; het resultaat begint
 * altijd met `/` en valt terug op `/` (de root) als er niets overblijft.
 */
export function parentRoute(pathname: string): string {
  const segments = pathname.split('/').filter(Boolean)
  if (segments.length <= 1) return '/'
  segments.pop()
  return `/${segments.join('/')}`
}
